import "jquery";
import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueRouter from "vue-router";
import routes from "./routes";

import Star from "@/views/components/Star.vue";
import Errors from "@/views/components/Errors.vue";
import ApiService from "./core/services/api.service";

/* import the fontawesome core */
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
	faUserSecret,
	faEye,
	faEnvelope,
	faKey,
	faBackward,
	faForward,
	faLayerGroup,
	faHouseDamage,
	faArrowDown,
	faUsers,
	faUser,
	faTasks,
	faBook,
	faCodeBranch,
	faChartBar,
	faUniversity,
	faCalendarWeek,
	faHandHoldingDollar,
	faExchangeAlt,
	faPiggyBank,
	faMoneyBill,
	faUserCircle,
	faTrash,
	faEdit,
	faShare,
	faBriefcase,
	faWeightHanging,
	faWindowRestore,
	faSearch,
	faSave,
	faTimes,
	faCircleCheck,
	faMoneyBillTransfer,
	faCheck,
	faBan,
	faArrowRotateLeft,
	faCircle,
	faFileExcel,
	faDownload,
	faHandHolding,
	faCaretSquareDown,
	faUpload,
	faFilter,
	faPlus,
	faRotateRight,
	faClose,
	faFilePdf,
	faCalculator,
	faCertificate,
	faPeopleGroup,
	faDoorOpen,
	faScaleBalanced,
	faLegal,
	faReceipt,
	faLink,
	faToggleOn,
	faToggleOff,
	faPrint,
	faPaperclip,
	faMailForward,
	faCirclePlay,
	faEllipsis,
	faPaperPlane,
	faDollarSign,
	faHistory,
	faUserFriends,
	faMapMarker,
	faMapMarkedAlt,
	faMapLocation,
	faMapMarkerAlt,
	// fa Icon to represent loan repayment
	faHandHoldingUsd,
	faEllipsisV,
	faMagnifyingGlass,
	faBarsProgress,
	faCopy,
	faLandmark
} from "@fortawesome/free-solid-svg-icons";

library.add(
	faUserSecret,
	faEye,
	faEnvelope,
	faKey,
	faBackward,
	faForward,
	faLayerGroup,
	faHouseDamage,
	faArrowDown,
	faUsers,
	faUser,
	faTasks,
	faBook,
	faCodeBranch,
	faChartBar,
	faUniversity,
	faCalendarWeek,
	faHandHoldingDollar,
	faExchangeAlt,
	faPiggyBank,
	faMoneyBill,
	faUserCircle,
	faTrash,
	faEdit,
	faShare,
	faBriefcase,
	faWeightHanging,
	faWindowRestore,
	faSearch,
	faSave,
	faTimes,
	faCircleCheck,
	faMoneyBillTransfer,
	faCheck,
	faBan,
	faArrowRotateLeft,
	faCircle,
	faFileExcel,
	faDownload,
	faHandHolding,
	faCaretSquareDown,
	faUpload,
	faFilter,
	faPlus,
	faRotateRight,
	faClose,
	faFilePdf,
	faCalculator,
	faCertificate,
	faPeopleGroup,
	faDoorOpen,
	faScaleBalanced,
	faLegal,
	faReceipt,
	faLink,
	faToggleOn,
	faToggleOff,
	faPrint,
	faPaperclip,
	faMailForward,
	faCirclePlay,
	faEllipsis,
	faPaperPlane,
	faDollarSign,
	faHistory,
	faUserFriends,
	faMapMarker,
	faMapMarkedAlt,
	faMapLocation,
	faMapMarkerAlt,
	faHandHoldingUsd,
	faEllipsisV,
	faMagnifyingGlass,
	faBarsProgress,
	faCopy,
	faLandmark
);

import "./assets/css/styles.css";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-vue/dist/bootstrap-vue.js";

import VueProgressBar from "vue-progressbar";
import swal from "sweetalert2";
import VueGoodTablePlugin from "vue-good-table";

// import the styles
import "vue-good-table/dist/vue-good-table.css";

// LeafMap
import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet.js';
//start vuetable

import Vuetable from "vuetable-2/src/components/Vuetable";
import VueTablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VueTablePaginationDropDown from "vuetable-2/src/components/VuetablePaginationDropdown";

import VeeValidate from "vee-validate";

import { hasPermission } from "./helper";

//end vuetable

// API service init
ApiService.init();

window.swal = swal;
const toast = swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 5000,
	timerProgressBar: true,
	onOpen: (toast) => {
		toast.addEventListener("mouseenter", swal.stopTimer);
		toast.addEventListener("mouseleave", swal.resumeTimer);
	},
	background: "#ffffff",
});
Vue.use(VueProgressBar, {
	// color: 'rgb(143,255,199)',
	color: "blue",
	failedColor: "red",
	height: "6px",
});
Vue.use(VueGoodTablePlugin);

window.toast = toast;

Vue.use(VeeValidate, {
	inject: true,
	fieldsBagName: "veeFields",
	errorBagName: "veeErrors",
});

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("star", Star);
Vue.component("errors", Errors);

Vue.component("vuetable", Vuetable);
Vue.component("vuetable-pagination", VuetablePagination);
Vue.component("vuetable-pagination-dropdown", VueTablePaginationDropDown);
Vue.component("vuetable-pagination-info", VueTablePaginationInfo);
// Vue.component('search-bar', SearchBar);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.mixin({
	// data: function () {
	//     return {
	//         api_url: config.api_url,
	//     }
	// },
	methods: {
		isEmpty: function (strIn) {
			if (strIn === undefined) {
				return true;
			} else if (strIn == null) {
				return true;
			} else if (strIn == "") {
				return true;
			} else {
				return false;
			}
		},
		getFormattedDateTime: function () {
			const now = new Date();
			const year = now.getFullYear();
			const month = String(now.getMonth() + 1).padStart(2, "0");
			const day = String(now.getDate()).padStart(2, "0");
			const hours = String(now.getHours()).padStart(2, "0");
			const minutes = String(now.getMinutes()).padStart(2, "0");
			const seconds = String(now.getSeconds()).padStart(2, "0");

			// Create the formatted date-time string separated with underscores
			const formattedDateTime = `${year}${month}${day}${hours}${minutes}${seconds}_`;

			// Update the data property
			return formattedDateTime;
		},
		formatDateAndTime(dateStr) {
			const date = new Date(dateStr);
			// return new Intl.DateTimeFormat('en-US', {
			// 	dateStyle: 'medium',
			// 	timeStyle: 'short',
			// 	timeZone: 'UTC', // or use your local timeZone like 'Africa/Accra'
			// }).format(date);

			// Format date part: Jun 9, 2025
			const datePart = date.toLocaleDateString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				timeZone: 'UTC',
			});

			// Format time part: 3:18 PM
			const timePart = date.toLocaleTimeString('en-US', {
				hour: 'numeric',
				minute: '2-digit',
				second: "2-digit",
				hour12: true,
				timeZone: 'UTC',
			});

			return `${datePart} - ${timePart}`;
		},
		formatDate(dateStr) {
			const date = new Date(dateStr);

			const datePart = date.toLocaleDateString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				timeZone: 'UTC',
			});

			return `${datePart}`;
		},
		formatNumber(num) {
			// if(num == null || num === undefined) return 0;
			// return parseFloat(num).toFixed(2)
			if (num) {
				return parseFloat(num).toFixed(2);
			} else {
				return 0;
			}
		},
		// displayNumber(number) {
		//   if (number && number != null && number != undefined && number != "0") {
		//     // parseFloat
		//     let num = parseFloat(number);
		//     if (isNaN(num)) {
		//       return 0.00;
		//     }
		//     // return Number(number ? number.toFixed(2) : 0.00).toLocaleString()
		//     return Number(number).toLocaleString()
		//   }
		//   else {
		//     return 0.00;
		//   }
		// },
		// displayNumber(number, num2)
		// {
		//   let numba = number + num2;
		//   return Number(number ? number.toFixed(2) : 0).toLocaleString()
		// },
		displayNumber(number) {
			if (
				number &&
				number != null &&
				number != undefined &&
				number != "0"
			) {
				// parseFloat
				let num = parseFloat(number);
				if (isNaN(num)) {
					return "0.00";
				}
				// First fix to 2 decimal places, then apply thousand separator
				return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return "0.00";
			}
		},
		displayCountingNumber(number) {
			if (
				number &&
				number != null &&
				number != undefined &&
				number != "0"
			) {
				// parseFloat
				let num = parseFloat(number);
				if (isNaN(num)) {
					return "0";
				}
				// First fix to 2 decimal places, then apply thousand separator
				return num.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			} else {
				return "0";
			}
		},
		getOneMonthEailer() {
			let currentDate = new Date();
			// Subtract one month
			currentDate.setMonth(currentDate.getMonth() - 1);
			// Convert the date to ISO string and extract only the date part
			let oneMonthEarlier = currentDate.toISOString().substr(0, 10);
			return oneMonthEarlier;
		},
		//get beginning of the year
		getBeginningOfYear() {
			let currentDate = new Date();
			// Subtract one month
			currentDate.setMonth(0);
			currentDate.setDate(1);
			// Convert the date to ISO string and extract only the date part
			let beginningOfYear = currentDate.toISOString().substr(0, 10);
			return beginningOfYear;
		},
		getStartOfWeek() {
			const today = new Date();
			const startOfWeek = new Date(today);
			const day = startOfWeek.getDay();
			const diff = startOfWeek.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is Sunday
			startOfWeek.setDate(diff);
			return startOfWeek.toISOString().substr(0, 10);
		},
		getLastDayOfMonth(year, month) {
			// Month is 0-indexed (0 for January, 11 for December)
			let lastDay = new Date(year, month + 1, 0);
			return lastDay.toISOString().split("T")[0];
		},
		getOneMonthAfterSelected(data) {
			let currentDate = new Date(data);
			let year = currentDate.getFullYear();
			let month = currentDate.getMonth(); // 0-indexed

			return this.getLastDayOfMonth(year, month);
		},
		getOneMonthBeforeDate() {
			const today = new Date();
			const oneMonthBefore = new Date(today);
			oneMonthBefore.setMonth(today.getMonth() - 1);

			// Handle edge case for months with fewer days
			if (oneMonthBefore.getMonth() === today.getMonth()) {
				oneMonthBefore.setDate(0);
			}

			// Format as YYYY-MM-DD
			const year = oneMonthBefore.getFullYear();
			const month = String(oneMonthBefore.getMonth() + 1).padStart(2, '0');
			const day = String(oneMonthBefore.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		numberToWords(num) {
			if (num != undefined) {
				const belowTwenty = [
					"",
					"One",
					"Two",
					"Three",
					"Four",
					"Five",
					"Six",
					"Seven",
					"Eight",
					"Nine",
					"Ten",
					"Eleven",
					"Twelve",
					"Thirteen",
					"Fourteen",
					"Fifteen",
					"Sixteen",
					"Seventeen",
					"Eighteen",
					"Nineteen",
				];
				const tens = [
					"",
					"",
					"Twenty",
					"Thirty",
					"Forty",
					"Fifty",
					"Sixty",
					"Seventy",
					"Eighty",
					"Ninety",
				];
				const aboveThousand = ["", "Thousand", "Million", "Billion"];

				if (num === 0) return "Zero";

				let words = "";

				function helper(n) {
					if (n < 20) return belowTwenty[n];
					if (n < 100)
						return (
							tens[Math.floor(n / 10)] +
							(n % 10 ? " " + belowTwenty[n % 10] : "")
						);
					if (n < 1000)
						return (
							belowTwenty[Math.floor(n / 100)] +
							" Hundred" +
							(n % 100 ? " " + helper(n % 100) : "")
						);
					for (let i = 0; i < aboveThousand.length; i++) {
						const unit = Math.pow(1000, i);
						if (n < unit * 1000) {
							return (
								helper(Math.floor(n / unit)) +
								" " +
								aboveThousand[i] +
								(n % unit ? " " + helper(n % unit) : "")
							);
						}
					}
				}

				words = helper(num);
				return words.trim();
			}
		},
		formatNumberWithInitials(num) {
			const absNum = Math.abs(num);
			let formatted;

			if (absNum >= 1_000_000_000) {
				formatted = (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
			} else if (absNum >= 1_000_000) {
				formatted = (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
			} else if (absNum >= 1_000) {
				formatted = (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
			} else {
				formatted = num.toLocaleString(); // adds commas for thousands
			}

			return `GHS ${formatted}`;
		}
		,
		convertMoneyToWords(amount) {
			if (amount != undefined) {
				const [wholePart, decimalPart] = amount.toString().split(".");
				let words = this.numberToWords(parseInt(wholePart)) + " Cedis";

				if (decimalPart) {
					words +=
						" and " +
						this.numberToWords(parseInt(decimalPart)) +
						" Perswas";
				}

				return words;
			}
		},
		excelDateToYMD(excelDate) {
			// Check if it's actually an Excel date (number > 1 and reasonable range)
			if (typeof excelDate === 'number' && excelDate > 1 && excelDate < 2958466) {
				const jsDate = new Date((excelDate - 25569) * 86400 * 1000);
				const year = jsDate.getFullYear();
				const month = String(jsDate.getMonth() + 1).padStart(2, '0');
				const day = String(jsDate.getDate()).padStart(2, '0');
				return `${year}-${month}-${day}`;
			}

			// If not an Excel date, return as-is (assuming it's already a date string)
			return excelDate;
		},
		loadGoogleMapsScript() {
			return new Promise((resolve) => {
				if (typeof google !== 'undefined') {
					return resolve()
				}
				const script = document.createElement('script')
				script.src = `https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY`
				script.async = true
				script.defer = true
				script.onload = resolve
				document.head.appendChild(script)
			})
		},

		extractLatLng(str) {
			const regex = /Lat:\s*([-+]?[0-9]*\.?[0-9]+),\s*Lng:\s*([-+]?[0-9]*\.?[0-9]+)/;
			const match = str.match(regex);

			if (match) {
				const lat = parseFloat(match[1]);
				const lng = parseFloat(match[2]);
				return { lat, lng };
			} else {
				return null; // if no match is found
			}
		},

		getCustomerFullName(customer) {
			return [customer?.first_name, customer?.middlename, customer?.last_name]
				.filter(Boolean)
				.join(" ")
		},
		getUserFullName(user) {
			return [user?.first_name, user?.surname]
				.filter(Boolean)
				.join(" ")
		}
	},
});

const router = new VueRouter({
	routes: routes,
	mode: "history",
});

// // Global before guard
// router.beforeEach((to, from, next) => {
// 	// Check if the route requires a specific permission
// 	if (to.meta && to.meta.permission) {
// 		const requiredPermission = to.meta.permission;
// 		if (hasPermission(requiredPermission)) {
// 			next(); // Allow navigation
// 		} else {
// 			next({ path: "/unauthorized" }); // Redirect to unauthorized page
// 		}
// 	} else {
// 		next(); // Allow navigation if no permission is required
// 	}
// });

// Add this function before the router configuration
function isAuthenticated() {
	const token = localStorage.getItem("token");
	return !!token; // Returns true if token exists, false otherwise
}

// Modify your router beforeEach guard
router.beforeEach((to, from, next) => {
	// Routes that don't require authentication
	const publicRoutes = ['/login', '/register', '/forgot-password'];

	// Check if the current route is public
	const isPublicRoute = publicRoutes.includes(to.path);

	// If not authenticated and trying to access a protected route
	if (!isAuthenticated() && !isPublicRoute) {
		next({ path: '/login' });
		return;
	}

	// If authenticated and trying to access login page, redirect to home
	if (isAuthenticated() && to.path === '/login') {
		next({ path: '/' });
		return;
	}

	// Check if the route requires a specific permission
	if (to.meta && to.meta.permission) {
		const requiredPermission = to.meta.permission;
		if (hasPermission(requiredPermission)) {
			next(); // Allow navigation
		} else {
			next({ path: "/unauthorized" }); // Redirect to unauthorized page
		}
	} else {
		next(); // Allow navigation if no permission is required
	}
});

new Vue({
	router,
	render: (h) => h(App),
}).$mount("#app");
